import { Controller } from "react-hook-form";
import { DatePicker } from '@mui/lab';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { TextField, Typography } from "@mui/material";
import trLocale from 'date-fns/locale/tr';
import { InputformatDate, InputformatJustDate } from "../../util/DateUtil";
import { useState } from "react";

export const CustomDateField = ({ name, label, control, errors, disabled, required }) => {

    const [lastValue, setLastValue] = useState("");
    const handleInput = (e) => {
        const input = e.target;
        const currentValue = input.value;

        // If length decreased, it means user is deleting => don't format
        if (currentValue.length < lastValue.length) {
            setLastValue(currentValue);
            return; // don't reformat on delete
        }

        // Else format normally
        input.value = handleInputFormat(currentValue);
        setLastValue(input.value)
    };


    const handleInputFormat = (value) => {

        // Remove all non-digit characters
        let digits = value.replace(/\D/g, '');

        if (digits.length > 8) digits = digits.slice(0, 8);

        let formatted = '';
        if (digits.length >= 2) formatted += digits.slice(0, 2) + '.';
        else formatted += digits;

        if (digits.length >= 4) formatted += digits.slice(2, 4) + '.';
        else if (digits.length > 2) formatted += digits.slice(2);

        if (digits.length > 4) formatted += digits.slice(4);

        return formatted;
    };


    // Normalize to local Date without time
    const toLocalDateOnly = (date) => {
        if (!date) return null;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    // Parse ISO string or Date
    const normalizeValue = (val) => {
        if (!val) return null;
        const d = typeof val === 'string' ? new Date(val) : val;
        return toLocalDateOnly(d);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={trLocale}>
            <Controller
                name={name}
                control={control}
                render={({ field: { ref, value, onChange, ...field } }) => (
                    <DatePicker
                        value={normalizeValue(value)}
                        onChange={(date) => onChange(InputformatDate(date))}
                        inputFormat="dd.MM.yyyy"
                        disabled={disabled}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                {...field}
                                fullWidth
                                margin="normal"
                                variant="outlined"
                                error={!!errors[name]}
                                helperText={errors[name]?.message || ''}
                                label={
                                    <Typography variant="h6" fontWeight="bold" color="text.dark">
                                        {label} {required && <span style={{ color: "red" }}>*</span>}
                                    </Typography>
                                }
                                inputProps={{
                                    ...params.inputProps,
                                    maxLength: 10,
                                    onInput: handleInput,
                                }}
                            />
                        )}
                    />
                )}
            />
        </LocalizationProvider>
    );
};
